module.exports = __webpack_public_path__ + "img/logo-256x256.a9650748.png";